import { makeFuzzyRegExp } from 'customer-data-objects/search/FieldSearch';
import { useCallback, useContext, useMemo } from 'react';
import { useStrategy } from './useStrategy';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { useEditorActions } from './useEditorActions';
import { getIntegrationAppId } from '../utils/getIntegrationAppId';
import { stripDiacritics } from 'foundations-components/transitional/utils/Diacritics';
const checkOption = (option, pattern) => {
  return pattern.test(stripDiacritics(option.text));
};

// @ts-expect-error ts-migrate(7023) FIXME: 'findOption' implicitly has return type 'any' beca... Remove this comment to see the full error message
const findOption = (options, optionValue) => {
  for (const option of options) {
    if (option.value === optionValue) {
      return option;
    }
    if (option.options) {
      // @ts-expect-error ts-migrate(7022) FIXME: 'nestedOption' implicitly has type 'any' because i... Remove this comment to see the full error message
      const nestedOption = findOption(option.options, optionValue);
      if (nestedOption) {
        return nestedOption;
      }
    }
  }
  return undefined;
};
export const useFilterFamilyOptions = (searchString = '', useGroupedFilterFamilyOptions = true) => {
  const {
    selectedFilterFamilyGroup
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFilterFamilyOptions,
    getGroupedFilterFamilyOptions
  } = useStrategy();
  const {
    selectFilterFamily
  } = useEditorActions();
  const allOptions = useMemo(() => {
    if (useGroupedFilterFamilyOptions && selectedFilterFamilyGroup) {
      return getGroupedFilterFamilyOptions(selectedFilterFamilyGroup, {
        integrationAppId: getIntegrationAppId(selectedFilterFamilyGroup)
      });
    }
    return getFilterFamilyOptions();
  }, [getFilterFamilyOptions, getGroupedFilterFamilyOptions, selectedFilterFamilyGroup, useGroupedFilterFamilyOptions]);
  const pattern = makeFuzzyRegExp(stripDiacritics(searchString));
  const filteredOptionGroups = [];
  for (const optionsGroup of allOptions) {
    const optionsGroupFiltered = {
      text: optionsGroup.text,
      options: [],
      category: optionsGroup.category
    };
    for (const option of optionsGroup.options) {
      if (checkOption(option, pattern)) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
        optionsGroupFiltered.options.push(option);
      }
    }
    if (optionsGroupFiltered.options.length) {
      filteredOptionGroups.push(optionsGroupFiltered);
    }
  }
  const hasOnlyOneFilterFamilyOption = allOptions.length === 1 && allOptions[0].options.length === 1;
  const selectTheOnlyFilterFamily = useCallback(() => {
    if (hasOnlyOneFilterFamilyOption) {
      const option = allOptions[0].options[0];
      selectFilterFamily(option.value, option.isAssociation);
    }
  }, [allOptions, selectFilterFamily, hasOnlyOneFilterFamilyOption]);
  const getTopLevelFilterFamilyOptionLabel = useCallback(optionValue => {
    const topLevelOptions = getFilterFamilyOptions();
    const option = findOption(topLevelOptions, optionValue);
    return option ? option.text : optionValue;
  }, [getFilterFamilyOptions]);
  return {
    filterFamilyOptions: filteredOptionGroups,
    selectTheOnlyFilterFamily,
    hasOnlyOneFilterFamilyOption,
    getTopLevelFilterFamilyOptionLabel
  };
};